// Serialises the Recharts SVG (+ title & legend) into a PNG data URL.
export async function chartToPng(container, { title, legend = [], bg = "#ffffff", fg = "#222222" }) {
  const svg = container?.querySelector("svg.recharts-surface");
  if (!svg) return null;
  const { width, height } = svg.getBoundingClientRect();
  const clone = svg.cloneNode(true);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("width", String(width));
  clone.setAttribute("height", String(height));
  clone.setAttribute("style", "font-family: Helvetica, Arial, sans-serif");
  const xml = new XMLSerializer().serializeToString(clone);
  const img = new Image();
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xml)}`;
  });
  const scale = 2;
  const perRow = Math.max(1, Math.floor(width / 170));
  const head = 30 + Math.ceil(legend.length / perRow) * 16 + 6;
  const canvas = document.createElement("canvas");
  canvas.width = width * scale;
  canvas.height = (height + head) * scale;
  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, width, height + head);
  ctx.fillStyle = fg;
  ctx.font = "bold 13px Helvetica, Arial, sans-serif";
  ctx.fillText(title, 10, 20);
  ctx.font = "11px Helvetica, Arial, sans-serif";
  legend.forEach((l, i) => {
    const x = 10 + (i % perRow) * 170;
    const y = 36 + Math.floor(i / perRow) * 16;
    ctx.fillStyle = l.color;
    ctx.fillRect(x, y - 8, 12, 8);
    ctx.fillStyle = fg;
    ctx.fillText(l.label, x + 16, y);
  });
  ctx.drawImage(img, 0, head, width, height);
  return canvas.toDataURL("image/png");
}

export function downloadHref(href, filename) {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
}

export function downloadBlob(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]));
  downloadHref(url, filename);
  window.URL.revokeObjectURL(url);
}
